import { checkKennzahlenPlausibel } from './routinen/checkKennzahlenPlausibel';
import { DataService } from '../../../services/data_service';
import DialogWrapper2 from '../../../core/dialog/dialog_wrapper_v2';
import { IDs } from '../../../helpers/IDs';
import { importRow } from './routinen/importRow';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WSimpleTupelList } from '../../../core/lists/WSimpleTupelList';

export interface KennzahlenImportEToolDialogProps {
    onClose: () => void;
    onSave: (data: any, callback?: () => void) => void;
    importRow: any;
    data: any;
}
export interface KennzahlenImportEToolDialogState {
    tempRow?: any;
}

export class KennzahlenImportEToolDialog extends React.Component<KennzahlenImportEToolDialogProps, KennzahlenImportEToolDialogState> {
    constructor(props: any) {
        super(props);
        this.state = {};
        this.declineData = this.declineData.bind(this);
        this.unplausibelData = this.unplausibelData.bind(this);
        this.saveData = this.saveData.bind(this);
        this.importData = this.importData.bind(this);
        this.selectIgnore = this.selectIgnore.bind(this);
        this.selectAllow = this.selectAllow.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.init();
    }

    hasChanged(): boolean {
        const row = (this.state.tempRow || this.props.importRow) || {};
        const comp1: any[] = (JSON.parse((this.props.importRow || {}).daten || '[]') || [])
            .map((item: any) => { return { allow: item.allow || false, ignore: item.ignore || false }; });
        const comp2: any[] = (row.daten_arr || comp1)
            .map((item: any) => { return { allow: item.allow || false, ignore: item.ignore || false }; });
        return JSON.stringify(comp1) !== JSON.stringify(comp2);
    }

    init(): void {
        const row: any = this.props.importRow || {};
        const plausibel: any = checkKennzahlenPlausibel(row, this.props.data);
        row.daten_arr = row.daten_arr || JSON.parse(row.daten || '[]');

        if (!(row.daten_arr || []).length) {
            return;
        }

        row.daten_arr.forEach((item: any) => {
            const status: string = ((plausibel || {})[item.kuerzel] || {}).plausi_status || null;

            if (typeof item.allow !== 'undefined' || typeof item.ignore !== 'undefined') {
            } else if (status === 'ok') {
                item.allow = true;
                item.ignore = false;
            } else if (status === 'prüfen') {
                item.allow = false;
                item.ignore = true;
            }
        });
        this.setState({ tempRow: row });
    }

    render(): JSX.Element {
        const row = this.state.tempRow ? this.state.tempRow : this.props.importRow;
        const plausibel = checkKennzahlenPlausibel(row, this.props.data);
        return (
            <DialogWrapper2
                onAfterClose={this.props.onClose}
                title='Import E-Tool-Daten'
            >
                {this.renderRow(plausibel)}
                {this.renderButtons(plausibel)}
            </DialogWrapper2>
        );
    }

    declineData(): void {
        const row = this.props.importRow;
        const status_item = { tid: row.tid, status: 2 };
        this.dataService.saveData(IDs.ENT_KENNZAHLEN_IMPORT, status_item, undefined, false, (suc: boolean, saveTid: number) => {
            this.triggerService.fire('reload', IDs.ENT_KENNZAHLEN_IMPORT);
            alert('Daten wurden abgelehnt!');
            this.props.onClose();
        }, IDs.MOD_ETOOL_ADMIN);
    }

    unplausibelData(): void {
        const row = this.props.importRow;
        const status_item = { tid: row.tid, status: 3 };
        this.dataService.saveData(IDs.ENT_KENNZAHLEN_IMPORT, status_item, undefined, false, (suc: boolean, saveTid: number) => {
            this.triggerService.fire('reload', IDs.ENT_KENNZAHLEN_IMPORT);
            alert('Daten wurden als unplausibel markiert');
            this.props.onClose();
        }, IDs.MOD_ETOOL_ADMIN);
    }

    saveData(): void {
        const row: any = this.state.tempRow || {};
        const status_item: any = { tid: row.tid, daten: JSON.stringify(row.daten_arr) };
        this.dataService.saveData(IDs.ENT_KENNZAHLEN_IMPORT, status_item, undefined, false, (suc: boolean, saveTid: number) => {
            this.triggerService.fire('reload', IDs.ENT_KENNZAHLEN_IMPORT);
            if (suc) {
                this.props.onSave(
                    { ...this.props.importRow, ...status_item },
                    () => setTimeout(() => alert('Daten wurden markiert'))
                );
            }
        }, IDs.MOD_ETOOL_ADMIN);
    }

    importData(): void {
        const row = this.props.importRow;
        importRow(row, this.props.data, this.dataService, this.triggerService, this.props.onClose);
    }

    renderButtons(plausibel: any): JSX.Element {
        return <>
            <div style={{ fontSize: 16, textAlign: 'center', padding: 20, fontWeight: 'bold' }}>
                {plausibel.result ? 'Der Datenatz ist plausibel' : 'Der Datensatz ist unplausibel'}
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', margin: 20, justifyContent: 'center' }}>
                <div>
                    <button style={{ padding: 10, margin: 15, backgroundColor: '#afa'}} onClick={this.importData}>
                        Daten importieren
                    </button>
                </div>
                <div>
                    <button style={{ padding: 10, margin: 15, backgroundColor: '#faa' }} onClick={this.declineData}>
                        Daten ablehnen
                    </button>
                </div>
                <div>
                    <button style={{ padding: 10, margin: 15, backgroundColor: '#fd8' }} onClick={this.unplausibelData}>
                        Daten als unplausibel markieren
                    </button>
                </div>
                {/*this.state.tempRow*/this.hasChanged() &&
                    <div>
                        <button style={{ padding: 10, margin: 15, backgroundColor: '#ccc' }} onClick={this.saveData}>
                            Daten speichern
                        </button>
                    </div>
                }
                <div>
                    <button style={{ padding: 10, margin: 15, backgroundColor: '#ccc' }} onClick={() => this.props.onClose()}>
                        Dialog Schließen (ohne Aktion)
                    </button>
                </div>
            </div>
        </>;
    }

    renderRow(plausibel: any): JSX.Element {
        const row = this.state.tempRow ? this.state.tempRow : this.props.importRow;
        console.log('ROW: ', row);
        const gewerk = row.branchen_gewerke_tid;
        const jahr = row.jahr;
        const unternehmen = row.unternehmen;
        const daten = row.daten_arr ? row.daten_arr : JSON.parse(row.daten);
        const elements = daten.map((item: any) =>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ fontSize: 11, width: 300 }}><b>{item.name}</b></div>
                <div style={{ fontSize: 11, width: 120 }}>{item.wert}</div>
                <div style={{ fontSize: 11, width: 120 }}>{plausibel[item.kuerzel].plausi_quelle}</div>
                <div style={{ fontSize: 11, width: 120 }}>{plausibel[item.kuerzel].plausi_status}</div>
                <div style={{ fontSize: 11, width: 150 }}>Min: {plausibel[item.kuerzel].wert_min}</div>
                <div style={{ fontSize: 11, width: 150 }}>Max: {plausibel[item.kuerzel].wert_max}</div>
                {this.renderOption(item)}
            </div>
        );
        const tupels: any[] = [];
        tupels.push({ name: 'Jahr', value: jahr });
        tupels.push({ name: 'Gewerk', value: gewerk });
        tupels.push({ name: 'Unternehmen (Pseudonym)', value: unternehmen });
        tupels.push({ name: 'Daten', value: elements });
        return <WSimpleTupelList
            data={tupels}
            widthName={200}
            widthValue={1100}
        />;
    }

    renderOption(item: any): JSX.Element {
        const checkedIgnore = item.ignore;
        const checkedAllow = item.allow;
        return <div style={{ fontSize: 11, width: 150 }}>
            <input
                type='checkbox'
                checked={checkedIgnore}
                onClick={(evt: any) => this.selectIgnore(item, evt.target.checked)}
            /> Ignorieren
            <input
                type='checkbox'
                checked={checkedAllow}
                onClick={(evt: any) => this.selectAllow(item, evt.target.checked)}
            /> Freigeben
        </div>;
    }

    selectIgnore(item: any, checked: boolean): void {
        const row = this.state.tempRow ? this.state.tempRow : this.props.importRow;
        if (!row.daten_arr) {
            row.daten_arr = JSON.parse(row.daten);
        }
        const daten_item = row.daten_arr.find((d: any) => d.kuerzel === item.kuerzel);
        daten_item.ignore = checked;
        if (checked) {
            daten_item.allow = false;
        }
        console.log('Select allow: ', checked, row);
        this.setState({ tempRow: row });
    }

    selectAllow(item: any, checked: boolean): void {
        const row = this.state.tempRow ? this.state.tempRow : this.props.importRow;
        if (!row.daten_arr) {
            row.daten_arr = JSON.parse(row.daten);
        }
        const daten_item = row.daten_arr.find((d: any) => d.kuerzel === item.kuerzel);
        daten_item.allow = checked;
        if (checked) {
            daten_item.ignore = false;
        }
        console.log('Select allow: ', checked, row);
        this.setState({ tempRow: row });
    }
}
